const EARTH_RADIUS_MILES = 3959;

export function getDistanceMiles(lat1, lon1, lat2, lon2) {
  if ([lat1, lon1, lat2, lon2].some((value) => value == null || Number.isNaN(Number(value)))) {
    return Infinity;
  }

  const toRad = (deg) => (Number(deg) * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return EARTH_RADIUS_MILES * c;
}

export function isWithinRadius(origin, point, radiusMiles) {
  if (!origin || !point) return false;
  return getDistanceMiles(origin.lat, origin.lng, point.lat, point.lng) <= radiusMiles;
}

export const FEET_PER_MILE = 5280;
export const CHECK_IN_MAX_FEET = 100;

export function getDistanceFeet(lat1, lon1, lat2, lon2) {
  return getDistanceMiles(lat1, lon1, lat2, lon2) * FEET_PER_MILE;
}

export function isWithinFeet(origin, point, feet = CHECK_IN_MAX_FEET) {
  if (!origin || !point) return false;
  return getDistanceFeet(origin.lat, origin.lng, point.lat, point.lng) <= feet;
}

export function findMetroForCoordinates(lat, lng, metros) {
  if (lat == null || lng == null) return null;
  let closest = null;
  let closestDistance = Infinity;

  for (const metro of metros) {
    const distance = getDistanceMiles(lat, lng, metro.center.lat, metro.center.lng);
    if (distance <= metro.radiusMiles && distance < closestDistance) {
      closest = metro;
      closestDistance = distance;
    }
  }

  return closest;
}

export function resolveBarMetro(bar, metros) {
  if (!bar) return null;
  const byCoords = findMetroForCoordinates(bar.lat, bar.lng, metros);
  if (bar.metroId) {
    const byId = metros.find((metro) => metro.id === bar.metroId) || null;
    if (byId && isWithinRadius(byId.center, { lat: bar.lat, lng: bar.lng }, byId.radiusMiles)) {
      return byId;
    }
    if (byCoords) return byCoords;
    return byId;
  }
  return byCoords;
}

export function filterBarsByScope(bars, { origin, radiusMiles, metroId, metros }) {
  if (!Array.isArray(bars)) return [];

  return bars.filter((bar) => {
    const resolved = resolveBarMetro(bar, metros);

    if (metroId) {
      if (resolved?.id === metroId) return true;
      if (resolved && resolved.id !== metroId) return false;
      if (origin) {
        return isWithinRadius(origin, { lat: bar.lat, lng: bar.lng }, radiusMiles);
      }
      return false;
    }

    if (origin) {
      return isWithinRadius(origin, { lat: bar.lat, lng: bar.lng }, radiusMiles);
    }

    return true;
  });
}

import { isBroaderMetroNeighborhood, parseTownFromAddress, getBroaderMetroCoreName } from './barLocation';

export function inferBarCity(bar, metros) {
  const metro = resolveBarMetro(bar, metros);
  let city = bar.city || '';
  if (isBroaderMetroNeighborhood(bar.neighborhood)) {
    const core = getBroaderMetroCoreName(bar.neighborhood);
    if (!city || (core && city.toLowerCase() === core.toLowerCase())) {
      city = parseTownFromAddress(bar.address) || city;
    }
  }
  return {
    city: city || metro?.name || '',
    state: bar.state || metro?.state || '',
    metroId: bar.metroId || metro?.id || null,
  };
}
